import { render, staticRenderFns } from "./Philanthropy.vue?vue&type=template&id=275ce5c4&scoped=true&"
import script from "./Philanthropy.vue?vue&type=script&lang=js&"
export * from "./Philanthropy.vue?vue&type=script&lang=js&"
import style0 from "./Philanthropy.vue?vue&type=style&index=0&id=275ce5c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275ce5c4",
  null
  
)

export default component.exports